import { type AiLanguage } from './ai-language';

export const languageLabelMap: Record<AiLanguage, string> = {
  de: 'Deutsch',
  en: 'Englisch / English',
  it: 'Italienisch / Italiano',
  es: 'Spanisch / Español',
  fr: 'Französisch / Français',
  pt: 'Portugiesisch / Português',
  tr: 'Türkisch / Türkçe',
  po: 'Polnisch / Polski',
  nl: 'Niederländisch / Nederlands',
  se: 'Schwedisch /Svenska',
  ru: 'Russisch / Русский',
  sl: 'Slovenisch / Slovenčina',
  cs: 'Tschechisch / Čeština',
  lb: 'Luxemburgisch / Luxembourgish',
  ro: 'Rumänisch / Română',
  rs: 'Serbisch / Српски',
  hr: 'Kroatisch / Hrvatski',
  ar: 'Arabisch',
  ur: 'Urdu',
  sq: 'Albanisch',
  hi: 'Hindi',
};
